<template>
    <span>
        <el-popover
            placement="bottom"
            width="1250"
            @show="initData"
            trigger="manual"
            v-model="showPopover"
        >
            <div id="search-set">
                <ul class="search-list-box">
                    <template v-for="(outer, pIndex) in searchList">
                        <li
                            v-for="item in outer.list"
                            :key="item.name + pIndex"
                            :class="{ 'is-fussy': item.isFussy }"
                        >
                            <span class="label overflow-text" :title="item.name">{{item.name}}</span>
                            <div class="form-item">
                                <el-input
                                    class="text-box"
                                    v-if="item.type === 'advanceUser'"
                                    v-model="outer.data[item.value]"
                                    readonly
                                    @keyup.113.native="userDetaliSearch(pIndex,item)"
                                    @keyup.enter.native="userDetaliSearch(pIndex,item)"
                                    @blur="userDetaliSearch(pIndex,item)"
                                    @input="advanceCodeChange(pIndex,item)"
                                    @clear="advanceCodeChange(pIndex,item)"
                                    :disabled="showState"
                                >
                                    <template v-slot:append>
                                        <el-button
                                            :disabled="showState"
                                            @click="userDetaliSearch(pIndex,item)"
                                            icon="el-icon-search"
                                        ></el-button>
                                    </template>
                                    <template v-slot:suffix>
                                        <i
                                            :disabled="showState"
                                            @click="resetAdvanceParams(item)"
                                            class="el-input__icon el-icon-circle-close"
                                            v-if="outer.data[item.value]"
                                        ></i>
                                    </template>
                                </el-input>
                                <el-input
                                    class="text-box"
                                    v-if="item.type === 'advance'"
                                    v-model="outer.data[item.value]"
                                    :readonly="!item.advanceReadonly"
                                    @keyup.113.native="detaliSearch(pIndex,item,outer.data[item.value])"
                                    @keyup.enter.native="detaliSearch(pIndex,item,outer.data[item.value])"
                                    @blur="detaliSearchBlur(pIndex,item,outer.data[item.value])"
                                    @input="advanceCodeChange(pIndex,item)"
                                    @clear="advanceCodeChange(pIndex,item)"
                                    :disabled="showState"
                                >
                                    <template v-slot:append>
                                        <el-button
                                            :disabled="showState"
                                            @click="detaliSearch(pIndex,item,outer.data[item.value])"
                                            icon="el-icon-search"
                                        ></el-button>
                                    </template>
                                    <template v-slot:suffix>
                                        <i
                                            :disabled="showState"
                                            @click="resetAdvanceParams(item)"
                                            class="el-input__icon el-icon-circle-close"
                                            v-if="outer.data[item.value]"
                                        ></i>
                                    </template>
                                </el-input>
                                <el-input
                                    class="text-box"
                                    v-if="item.type === 'advanceMulti'"
                                    v-model="outer.data[item.value]"
                                    readonly
                                    @keyup.113.native="detaliListSearch(pIndex,item)"
                                    @keyup.enter.native="detaliListSearch(pIndex,item)"
                                    @blur="detaliListSearch(pIndex,item)"
                                    @input="advanceCodeChange(pIndex,item)"
                                    @clear="advanceCodeChange(pIndex,item)"
                                    :disabled="showState"
                                >
                                    <el-button
                                        slot="append"
                                        :disabled="showState"
                                        @click="detaliListSearch(pIndex,item)"
                                        icon="el-icon-search"
                                    ></el-button>
                                    <i
                                        slot="suffix"
                                        :disabled="showState"
                                        @click="resetAdvanceParams(item)"
                                        class="el-input__icon el-icon-circle-close"
                                        v-if="outer.data[item.value]"
                                    ></i>
                                </el-input>
                                <el-input
                                    class="text-box"
                                    :disabled="showState"
                                    :placeholder="item.placeholder || item.name"
                                    v-if="item.type === 'input'"
                                    v-model="outer.data[item.value]"
                                    @input="searchListChange(item, $event)"
                                >
                                    <template
                                        v-if="item.selectConfig && item.selectConfig.option"
                                        #prepend
                                    >
                                        <el-select
                                            v-model="item.selectConfig.value"
                                            :placeholder="item.selectConfig.placeholder || '请选择'"
                                            :class="item.selectConfig.class"
                                            :style="{ width: item.selectConfig.width || '60px' }"
                                            @change="inputSelectChange(item, outer.data, $event)"
                                        >
                                            <el-option
                                                v-for="(selItem, selIdx) in item.selectConfig.option"
                                                :key="selIdx"
                                                :label="selItem.label"
                                                :value="selItem.prop"
                                            ></el-option>
                                        </el-select>
                                    </template>
                                    <template v-slot:append>
                                        <el-button
                                            v-if="item.isFussy"
                                            :ref="`${item.value}FussyAdvancedCheckboxBtn`"
                                            @click="handleChangeFussy(!outer.data[item.value + 'Fussy'], outer.data, item)"
                                        >{{$translate('component.E202007300017', { defaultText: '模糊' })}}</el-button>
                                    </template>
                                </el-input>
                                <el-select
                                    class="text-box"
                                    v-model="outer.data[item.value]"
                                    v-if="item.type === 'select'"
                                    :clearable="_.get(item, 'clearable', true)"
                                    :multiple="item.multiple?item.multiple:false"
                                    :filterable="item.filterable"
                                    :disabled="showState"
                                    collapse-tags
                                    @change="searchListChange(item, $event)"
                                >
                                    <el-option
                                        v-for="(val, index) in item.options"
                                        :key="index"
                                        :label="val.label"
                                        :value="val.value"
                                    ></el-option>
                                </el-select>
                                <el-select
                                    v-else-if="item.type === 'autocomplete'"
                                    :clearable="_.get(item, 'clearable', true)"
                                    v-model="outer.data[item.passValue?item.passValue:item.value]"
                                    filterable
                                    remote
                                    :multiple="item.multiple?item.multiple:false"
                                    reserve-keyword
                                    :placeholder="item.name"
                                    :remote-method="remoteMethod"
                                    @focus="searchDateChange(item)"
                                    :loading="searchLoading"
                                    :disabled="showState"
                                    collapse-tags
                                >
                                    <el-option
                                        v-for="selectItem in item.options"
                                        :key="selectItem.id"
                                        :label="selectItem.label"
                                        :value="selectItem.passValue ? selectItem.value + '/' + selectItem.passValue : selectItem.value"
                                    ></el-option>
                                </el-select>
                                <addressSelect
                                    class="text-box"
                                    v-if="item.type === 'addressSelect'"
                                    v-model="outer.data[item.value]"
                                    :minLayers="item.minLayers"
                                    :placeholder="item.name"
                                    :basicProps="item.config"
                                    @change="searchListChange(item, $event)"
                                ></addressSelect>
                                <addressCascader
                                    class="text-box"
                                    v-if="item.type === 'addressCascader'"
                                    v-model="outer.data[item.value]"
                                    :minLayers="item.minLayers"
                                    :placeholder="item.name"
                                    :basicProps="item.config"
                                    :draggable="item.draggable"
                                    :triggerEvent="item.triggerEvent || 'click'"
                                    :hotData="item.hotData"
                                    :showNoChoice="item.showNoChoice"
                                ></addressCascader>
                                <el-date-picker
                                    class="text-box"
                                    v-if="item.type === 'time'"
                                    v-model="outer.data[item.value]"
                                    :clearable="_.get(item, 'clearable', true)"
                                    :disabled="showState"
                                    size="mini"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    :value-format="item.format||'yyyy-MM-dd HH:mm:ss'"
                                    :type="item.time?'daterange':'datetimerange'"
                                    unlink-panels
                                    :range-separator="$translate('component.E202007300014', { defaultText: '至' })"
                                    :start-placeholder="item.startPlaceholder ? item.startPlaceholder : $translate('component.E202007300015', { defaultText: '开始日期' })"
                                    :end-placeholder="item.endPlaceholder ? item.endPlaceholder : $translate('component.E202007300016', { defaultText: '结束日期' })"
                                    :picker-options="pickerOptions"
                                    :default-time="['00:00:00', '23:59:59']"
                                ></el-date-picker>
                                <el-date-picker
                                    v-if="['date','week','month','dates','year'].includes(item.type)"
                                    size="mini"
                                    class="text-box"
                                    v-model="outer.data[item.value]"
                                    :clearable="_.get(item, 'clearable', true)"
                                    :format="item.format"
                                    :value-format="item.valueFormat"
                                    :type="item.type"
                                    unlink-panels
                                    :placeholder="item.placeholder ? item.placeholder : $translate('lotsUI.select_date', { defaultText: '选择日期' })"
                                ></el-date-picker>
                                <slot name="search-append" v-if="item.slot"></slot>
                            </div>
                            <!-- <span class="input-append-fussy" v-if="item.isFussy">
                        <el-checkbox v-model="outer.data[item.value + 'Fussy']">{{$translate('component.E202007300017', { defaultText: '模糊' })}}</el-checkbox>
                            </span>-->
                        </li>
                    </template>
                </ul>
                <div v-if="!showState" class="btn-box">
                    <div class="text-btn">
                        <el-button
                            type="text"
                            @click="showStateOpen"
                        >{{$translate('component.E202007300020', { defaultText: '自定义搜索条件' })}}</el-button>
                    </div>
                    <div class="btn-btn">
                        <el-button
                            :loading="loading"
                            type="primary"
                            v-preventClick="isControl"
                            @click="search"
                        >{{$translate('component.E202006240012', { defaultText: '搜 索' })}}</el-button>
                        <el-button
                            type="text"
                            @click="clear"
                        >{{$translate('component.E202006240011', { defaultText: '重 置' })}}</el-button>
                    </div>
                </div>
                <div v-if="showState">
                    <p class="line"></p>
                    <p>{{$translate('component.E202011270006', { defaultText: '选择添加搜索条件' })}}</p>
                    <ul class="search-total-box">
                        <li v-for="(item,index) in searchTotalTitle" :key="index">
                            <el-button
                                :class="['btn-width overflow-text', item.select ? 'is-select' : 'is-unselect']"
                                plain
                                @click="btnChange(index)"
                            >{{item.name}}</el-button>
                        </li>
                    </ul>
                    <div class="btn-box">
                        <el-button
                            type="text"
                            @click="cancelSearch"
                        >{{$translate('component.E202006152345', { defaultText: '取消' })}}</el-button>
                        <el-button
                            type="primary"
                            @click="saveSearch"
                        >{{$translate('component.E202006152346', { defaultText: '保存' })}}</el-button>
                    </div>
                </div>
            </div>
            <advance-dialog ref="advanceDialog" @confirm="detaliSearchSure"></advance-dialog>
            <advance-multi-dialog
                ref="advanceMultiDialog"
                @confirm="detaliListSearchSure"
                @getCheckedList="detailCheckedList"
            ></advance-multi-dialog>
            <advance-user ref="advanceUser" @confirm="detaliSearchSure"></advance-user>
            <template v-slot:reference>
                <el-button
                    @click="showPopover = !showPopover;"
                >{{$translate('component.E202011270004', { defaultText: '高级' })}}</el-button>
            </template>
        </el-popover>
        <div class="search-set_back" v-show="showPopover" @click.self="showPopover = !showPopover;"></div>
    </span>
</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import _ from '@/components/lots/utils';
import { longRange, dict, getList } from '@/components/otpPanel/api';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import advanceMultiDialog from '@/components/lots/otpAdvanceMultiDialog';
import advanceUser from '@/components/lots/otpAdvanceUser';
import addressSelect from '@/components/lots/otpCascader2';
import { I18nMixins } from '@/components/utils/i18n';
import preventClick from '@/components/utils/directive';
import addressCascader from '@/components/lots/addressCascader';
export default {
    mixins: [I18nMixins, preventClick],
    components: { advanceDialog, addressSelect, advanceUser, addressCascader, advanceMultiDialog },
    props: {
        isControl: {
            type: Boolean,
            default: false
        },
        popPrefix: String,
        advancePrefix: String,
        longPrefix: String,
        searchTotalTitle: { // 高级-自定义搜索项
            type: Array,
            default () {
                return [];
            }
        },
        searchInitList: { // 高级列表
            type: Array,
            default () {
                return [];
            }
        },
        setSearchData: {
            type: Object,
            default () {
                return {};
            }
        },
        searchId: String,
        configurationUrl: String,
        filterable: Boolean,
        initSearchInfo: {
            type: Object,
            default () {
                return {};
            }
        },
        pickerOptions: {
            type: Object,
            default () {
                return {};
            }
        },
        keyMaps: {
            type: Object,
            default () {
                return {};
            }
        },
        /**
         * 为 true 时 对查询条件字段值进行 trim 而不是 替换空白字符
         */
        fieldTrim: {
            type: Boolean,
            default () {
                return false;
            }
        }
    },
    data () {
        return {
            timer: null,
            searchData: {},
            searchChange: [],
            searchSetList: [],
            selectNum: [],
            showState: false,
            advanceType: 0,
            searchSetTitle: [],
            options: [],
            searchLoading: false,
            selectItem: '',
            showPopover: false,
            loading: false,
            keyMap: {},
            resourceCode: '',
            advanceMultiCache: {},
            currentAdvanceMulti: {}
        };
    },
    methods: {
        // input模糊搜索change，v-model无效
        handleChangeFussy (e, data, item) {
            const v = item.value + 'Fussy';
            data[v] = e;
            this.$emit('handleVagueSearch', e, v, item);
            this.handleFussyDomClass(item, e);
        },
        handleFussyDomClass (item, val) {
            const parentNodeClassList = _.get(this, `$refs.${item.value}FussyAdvancedCheckboxBtn[0].$el.parentNode.classList`);
            if (!parentNodeClassList) return;
            if (val) { // checkbox-button的checked不生效，只能动态生成和删除class，用于高级里面的模糊搜索高亮
                parentNodeClassList.add('isActive');
            } else {
                parentNodeClassList.remove('isActive');
            }
        },
        searchListChange (item, val) {
            this.$emit('search-list-change', item, val);
        },
        // input 左边下拉框切换值
        inputSelectChange (item, searchData, val) {
            const optionItem = item.selectConfig.option.find(s => s.prop === val);
            item.placeholder = optionItem.label;
            searchData[item.selectConfig.prop] = val;
        },
        deepMenu (node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    for (let i = 0; i < childrens.length; i++) {
                        if (childrens[i].frontUrl === this.$route.fullPath) {
                            this.resourceCode = childrens[i].resourceCode;
                            return childrens[i].resourceCode;
                        } else {
                            this.deepMenu(childrens[i]);
                        }
                    }
                }
            }
        },
        btnChange (index) {
            this.searchTotalTitle[index].select = !this.searchTotalTitle[index].select;
            this.searchSetList = [];
            this.selectedShow();
        },
        cancelSearch () {
            this.getSetList().then(() => {
                this.creatSearchList();
                this.selectedShow();
            });
            this.showState = false;
        },
        showStateOpen () {
            this.showState = true;
        },
        saveSearch () {
            this.showState = false;
            let searchTotalTitle = [];
            let searchTotalName = [];
            this.searchSetList.forEach(data => {
                searchTotalTitle.push(data.name);
                searchTotalName.push(data.value);
            });
            searchTotalTitle = searchTotalTitle.join(',');
            searchTotalName = searchTotalName.join(',');
            const pramas = {
                'configName': searchTotalName,
                'configNameCn': searchTotalTitle,
                'subjectType': this.searchId,
                'moduleCode': this.resourceCode,
                'id': this.user.employeeId
            };
            getList.post(this.configurationUrl, pramas).then(() => {
            }).catch(() => { });
        },
        clear () {
            this.searchReset(null, true);
            this.$emit('init-search', null, true);
        },
        search () {
            const searchData = _.clone(this.searchData);
            if (this.searchChange.length !== 0) {
                this.searchChange.map(item => {
                    if (item.value !== item.startValue && item.value) {
                        delete searchData[item.endValue];
                    }
                });
            }
            const setSearchData = _.clone(this.setSearchData);
            const data = Object.assign({}, setSearchData, searchData);
            this.$emit('search', data);
            this.showPopover = false;
        },
        advanceCodeChange (num, current) {
            this.advanceType = num;
            this.currentSearchData[current.advanceCode] = '';
        },
        searchReset (searchDataIn = null, reset = false) {
            const searchData = searchDataIn || {};
            // 过滤有值的属性，只对未赋值的属性进行初始化
            this.searchSetList.filter(data => !searchData[data.value]).map(data => {
                if (reset || !this.initSearchInfo[data.value]) {
                    if (data.type === 'input' && data.isFussy) {
                        this.handleFussyDomClass(data, reset ? false : searchData[data.value + 'Fussy']);
                    } else if (data.type === 'time' && data.timeNum) {
                        const today = dayjs();
                        const startOfDay = today.startOf('day');
                        const endOfDay = today.endOf('day');
                        const start = data.future ? startOfDay.toDate() : startOfDay.subtract(data.timeNum, 'd').toDate();
                        const end = data.future ? endOfDay.add(data.timeNum, 'd').toDate() : today.endOf('day').toDate();
                        searchData[data.value] = [start, end];
                    } else if (data.type === 'advance') {
                        if (this.keyMap[data.value]) {
                            this.keyMap[data.value].forEach(key => { searchData[key] = ''; });
                        } else {
                            searchData[data.value] = '';
                        }
                    } else {
                        let item = '';
                        if (data.data) {
                            item = data.data;
                        } else if (data.multiple) {
                            item = [];
                        }
                        let key = data.value;
                        if (data.passValue) {
                            this.searchChange.push({ startValue: data.ganged, endValue: data.value, value: data.passValue });
                            key = data.passValue;
                        }
                        searchData[key] = item;
                    }
                } else {
                    searchData[data.value] = this.initSearchInfo[data.value];
                }
            });
            this.searchData = searchData;
        },
        searchInit () {
            // 只保存弹窗上存在的元素的属性
            const searchData = this.searchSetList.map(data => {
                // 初始化keyMap
                if (data.type === 'advance' && _.isArray(data.cbParams)) {
                    const keys = data.cbParams.map(item => {
                        const arr = item.split('#');
                        return arr[1] || arr[0];
                    });
                    keys.forEach(key => {
                        this.keyMap[key] = keys;
                    });
                }
                // input select 和 模糊
                if (data.type === 'input' && (data.selectConfig || data.isFussy)) {
                    const { selectConfig } = data;
                    const key2 = data.isFussy ? data.value + 'Fussy' : selectConfig.prop;
                    const arr = [data.value, key2];
                    // 初始化
                    this.keyMap[data.value] = this.keyMap[key2] = arr;
                }
                return data.value;
            }).reduce((result, prop) => {
                if (this.keyMap[prop]) {
                    this.keyMap[prop].forEach(key => {
                        result[key] = this.searchData[key];
                    });
                } else {
                    result[prop] = this.searchData[prop];
                }
                return result;
            }, {});
            this.searchReset(searchData);
        },
        userDetaliSearch (num, current) {
            this.advanceType = num;
            this.$refs.advanceUser.show(current);
        },
        detaliSearchBlur (num, current, searchData) {
            searchData = this.trimOrReplaceSpace(searchData);
            if (searchData !== '' && !current.advanceReadonly) {
                this.detaliSearch(num, current, searchData);
            }
        },
        // 高级弹框
        detaliSearch (num, current, searchData) {
            // 处理搜索条件前置效验(用于关联查询必填查询条件)
            // preValidation:前置效验参数
            // preValidationTip:前置效验参数未选提示
            if (!current.preValidation2 && current.preValidation) {
                if (!this.searchData[current.preValidation]) {
                    return this.$message.warning(current.preValidationTip);
                }
            }
            // 选择承运商入参
            if (current.preValidation2) {
                if (!this.setSearchData[current.preValidation2]) {
                    return this.$message.warning(current.preValidationTip2);
                }
            }
            this.advanceType = num;
            // 高级搜索级联操作，current.advanceCascade为需要级联的参数的key的集合，例如advanceCascade: key1,key2,key3
            const advanceCascade = {};
            if (_.isString(current.advanceCascade)) {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.searchData[sourceProp];
                });
            }
            // 选择承运商入参
            if (current.preValidation2) {
                advanceCascade.supplierCode = this.setSearchData.carrierCode;
            }
            // this.$refs.advanceDialog.show(true, current, advanceCascade);
            this.$refs.advanceDialog.show(true, current, advanceCascade, '', [], searchData);
        },
        detaliListSearch (num, current) {
            this.advanceType = num;
            // 高级搜索级联操作，current.advanceCascade为需要级联的参数的key的集合，例如advanceCascade: key1,key2,key3
            const advanceCascade = {};
            if (_.isString(current.advanceCascade)) {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.searchData[sourceProp];
                });
            }

            // advanceMultiCache：缓存选中数据
            this.currentAdvanceMulti = current;
            if (!this.advanceMultiCache[current.value]) this.advanceMultiCache[current.value] = [];
            const cache = this.advanceMultiCache[current.value];
            this.$refs.advanceMultiDialog.show(true, current, advanceCascade, cache.length ? cache : undefined);
        },
        detaliSearchSure (data, config) {
            // 将返回数据添加到map里，用于高级搜索清空时，顺带清空其他关联属性
            const keyArr = Object.keys(data);
            if (keyArr.length > 0) {
                keyArr.forEach(key => {
                    this.keyMap[key] = keyArr;
                });
            }
            Object.assign(this.currentSearchData, data);
            this.searchListChange(config, data);
        },
        detaliListSearchSure (data, config) {
            const keyArr = Object.keys(data[0]);
            const params = {};
            keyArr.forEach(key => {
                this.keyMap[key] = keyArr;
                if (!params[key]) params[key] = [];
                data.forEach(item => {
                    params[key].push(item[key]);
                });
                params[key] = params[key].join();
            });
            Object.assign(this.searchData, params);
            this.searchListChange(this.currentAdvanceMulti, data);
        },
        detailCheckedList (data) {
            this.advanceMultiCache[this.currentAdvanceMulti.value] = data;
        },
        getSetList () {
            const menu = { subResources: _.clone(this.menus) };
            this.deepMenu(menu);
            let checkedList = '';
            const pramas = {
                subjectType: this.searchId,
                moduleCode: this.resourceCode,
                id: this.user.employeeId
            };
            return getList.get(this.configurationUrl, pramas).then(data => {
                if (data.data) {
                    checkedList = data.data.configNameCn;
                    this.searchSetTitle = checkedList.split(',');
                } else {
                    this.searchSetTitle = [];
                }
            }).catch(() => {
                this.searchSetTitle = [];
            });
        },
        creatSearchList () {
            this.searchSetList = this.searchTotalTitle.map(item => {
                item.select = this.searchSetTitle.includes(item.name);
                return item;
            }).filter(item => item.select);
        },
        getRemoteMethod (query) {
            this.options = [];
            let searchData;
            if (query) {
                searchData = this.trimOrReplaceSpace(query);
            } else {
                searchData = '';
            }
            const params = {
                [this.selectItem.tableName]: {
                    [this.selectItem.value]: searchData,
                    [this.selectItem.ganged]: searchData
                }
            };
            if (this.selectItem.relevanceOne) {
                const temp = this.selectItem.relevanceOnePlace || this.selectItem.relevanceOne;
                params[this.selectItem.tableName][temp] = Array.isArray(this.setSearchData[this.selectItem.relevanceOne])
                    ? this.setSearchData[this.selectItem.relevanceOne].join(',') : this.setSearchData[this.selectItem.relevanceOne];
            }
            if (this.selectItem.relevanceTwo) {
                const temp = this.selectItem.relevanceTwoPlace || this.selectItem.relevanceTwo;
                params[this.selectItem.tableName][temp] = Array.isArray(this.setSearchData[this.selectItem.relevanceTwo])
                    ? this.setSearchData[this.selectItem.relevanceTwo].join(',') : this.setSearchData[this.selectItem.relevanceTwo];
            }
            longRange(this.longPrefix, params).then(data => {
                const restaurants = [];
                data.data[this.selectItem.tableName].map(search => {
                    restaurants.push({
                        'value': search[this.selectItem.ganged],
                        'label': search[this.selectItem.value],
                        'passValue': search[this.selectItem.autocompExtra],
                        'id': search[this.selectItem.uniqueID || 'id']
                    });
                });
                this.searchLoading = true;
                setTimeout(() => {
                    this.searchLoading = false;
                    const options = restaurants.filter(item => {
                        return item.label.toLowerCase()
                            .indexOf(searchData.toLowerCase()) > -1;
                    });
                    this.$nextTick(() => {
                        this.$set(this.selectItem, 'options', options);
                    });
                }, 20);
            });
        },
        remoteMethod (query) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.getRemoteMethod(query);
            }, 300);
        },
        searchDateChange (item) {
            this.selectItem = item;
            this.remoteMethod();
        },
        getOptionList () {
            this.searchTotalTitle.map(columns => {
                if (columns.optionNum) {
                    const params = {
                        dictCodes: columns.optionNum,
                        tenantCode: this.currentTenant.tenantCode
                    };
                    dict(this.popPrefix, params).then(data => {
                        const option = [];
                        for (const key in data.data[columns.optionNum]) {
                            if (data.data[columns.optionNum].hasOwnProperty(key)) {
                                option.push({ 'value': key, 'label': data.data[columns.optionNum][key] });
                            }
                        }
                        columns.options = option;
                    });
                }
            });
        },
        initData () {
            this.getSetList().then(() => {
                this.creatSearchList();
                this.selectedShow();
                this.showState = false;
                this.keyMap = this.keyMaps;// 关联keyMap 实现清除
            });
        },
        initInputSelect (item) {
            const { selectConfig } = item;
            this.searchData[selectConfig.prop] = selectConfig.value;
        },
        selectedShow () {
            const searchSetList = [];
            this.searchTotalTitle.map((data, index) => {
                if (data.type === 'input' && data.selectConfig) {
                    this.initInputSelect(data);
                }
                if (data.select) {
                    searchSetList.push(data);
                }
            });
            this.searchSetList = searchSetList;

            this.searchInit();
        },
        // 高级输入框的关闭按钮点击
        resetAdvanceParams (item) {
            const prop = item.value;
            const keyArr = this.keyMap[prop];
            // 把属性相关联的字段置空
            if (item.advanceReadonly) {
                this.currentSearchData[prop] = '';
            } else {
                keyArr.forEach(key => {
                    this.currentSearchData[key] = '';
                });
            }
            if (this.advanceMultiCache[prop]) {
                this.advanceMultiCache[prop] = [];
            }
        },
        changeLoading (status) {
            this.loading = status;
        },
        trimOrReplaceSpace (str) {
            if (this.fieldTrim) {
                return (str || '').trim();
            } else {
                return (str || '').replace(/\s*/g, '');
            }
        }
    },
    created () {
        this.getOptionList();
        this.$eventBus.$on(this.$route.name, () => {
            this.showPopover = false;
        });
    },
    watch: {
    },
    computed: {
        ...mapGetters(['currentTenant', 'menus', 'user']),
        _ () {
            return _;
        },
        searchList () {
            return [
                {
                    list: this.searchInitList,
                    data: this.setSearchData
                },
                {
                    list: this.searchSetList,
                    data: this.searchData
                }];
        },
        currentSearchData () {
            return this.advanceType === 0 ? this.setSearchData : this.searchData;
        }
    }
};

</script>
<style lang="less">
#search-set {
    .el-range-separator {
        width: 16px;
    }
    .overflow-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .el-input__inner {
        height: 28px !important;
        padding: 3px 25px;
    }
    ul {
        display: flex;
        flex-wrap: wrap;
    }
    .el-input-group__prepend {
        .el-select {
            width: 60px;
        }
        .el-input__inner {
            padding: 3px 16px 3px 5px;
        }
        .el-input__suffix {
            right: 2px;
        }
    }
    .is-select {
        color: #00bcbf;
        border-color: #00bcbf;
    }
    .is-unselect {
        color: #252626;
        border-color: #cecece;
    }

    .search-list-box {
        margin-top: 10px;
        max-height: 42vh;
        overflow-y: scroll;

        > li {
            width: 410px;
            margin-bottom: 10px;
            display: flex;

            > .label {
                display: inline-block;
                height: 28px;
                line-height: 28px;
                width: 120px;
                padding: 0 10px 0 0;
                text-align: right;
            }

            > .form-item {
                width: 320px;
                > div {
                    width: 100%;
                }
            }

            .select-btn {
                color: #eee !important;
            }
            &.is-fussy {
                .label {
                    width: 110px;
                }
                .el-input-group--append {
                    .el-input-group__append {
                        background-color: #fff;
                    }
                    .isActive {
                        background-color: #00bcbf;
                        color: #fff;
                    }
                }
                .form-item {
                    width: 290px;
                }
                .input-append-fussy {
                    width: 48px;
                    margin-top: 4px;
                    margin-left: 6px;
                    .el-checkbox__label {
                        padding-left: 4px;
                    }
                }
            }
        }
    }

    .line {
        height: 1px;
        width: 100%;
        background-color: #f2f2f2;
    }

    .search-total-box {
        max-height: 120px;
        overflow: auto;

        li {
            width: 162px;
            padding: 0 10px 10px 0;
        }
    }

    .btn-box {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        .text-btn {
            width: 40%;
        }
        .btn-btn {
            width: 60%;
            display: flex;
            justify-content: flex-end;
        }
    }

    .btn-width {
        width: 162px;
    }

    .text-box {
        position: relative;
        font-size: 12px;
        width: 100%;
    }
    .v-modal {
        z-index: 2000 !important;
    }
}
.search-set_back {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    // opacity: 0.5;
    // background: #000000;
}
</style>
